/**
 * @description 手機板載入時上方Tab選單調整Scrollbar，以確保當前active的選項可見。
 * @param {*} scrollbar 頁籤本體X軸
 * @param {*} active 所在頁面
 * @param {*} adjust
 */

function changeScrollbarPosition(scrollbarEl, activeEl, adjustNum = 0) {
  if (
    document.querySelectorAll(scrollbarEl).length > 0 &&
    document.querySelectorAll(activeEl).length > 0
  ) {
    const scrollbarElement = document.querySelector(scrollbarEl);
    const activeElement = document.querySelector(activeEl);
    moveScrollbar(scrollbarElement, activeElement, adjustNum);
  }
  function moveScrollbar(scrollbar, active, adjust) {
    const scrollBarWidth = scrollbar.offsetWidth;
    const activeItem = active;
    const activeRect = activeItem.getBoundingClientRect();
    const activePositionLeft = activeRect.left;
    const activePositionRight = activeRect.left + activeItem.offsetWidth;
    if (activePositionRight > scrollBarWidth) {
      scrollbar.scrollLeft = activePositionLeft + adjust - scrollbar.scrollLeft;
    }
  }
}

/**
 * 手機板載入時上方Tab選單調整Scrollbar，iphone 客製化
 * @description 需參考以下判斷是否為 iphone
 * @link [https://mrcodingroom.freesite.host/js-%E5%81%B5%E6%B8%AC%E8%A3%9D%E7%BD%AE%E6%98%AF%E5%90%A6%E7%82%BAios%E6%88%96ipad/]
 */

function customScrollbarX(scrollbarEl) {
  const detectBrowser = () => {
    if (/iPad|iPhone|iPod|Macintosh/.test(navigator.userAgent)) {
      try {
        document.createEvent('TouchEvent');
        return true;
      } catch (e) {
        return false;
      }
    }
    return false;
  };
  detectBrowser();
  if (detectBrowser()) {
    if (document.querySelectorAll(scrollbarEl).length > 0) {
      let content;

      if (document.querySelectorAll(scrollbarEl).length > 0) {
        content = document.querySelector(scrollbarEl);
      }
      content.style.marginBottom = '-10px';
      content.style.paddingBottom = '23px';

      const scrollRatio = content.clientWidth / content.scrollWidth;

      if (scrollRatio !== 1) {
        const scrollbarMarkup =
          '<div class="scrollbar"><div class="track"></div><div class="thumb"></div></div>';
        content.insertAdjacentHTML('afterend', scrollbarMarkup);

        const thumb = document.querySelector('.thumb');
        const track = document.querySelector('.track');
        thumb.style.width = `${scrollRatio * 100}%`;

        const scrollContentHandler = () => {
          window.requestAnimationFrame(() => {
            thumb.style.left = `${(content.scrollLeft * 100) / content.scrollWidth}%`;
          });
        };

        content.addEventListener('scroll', scrollContentHandler);

        let pos = { left: 0, x: 0 };

        const mouseMoveHandler = (e) => {
          const dy = e.clientX - pos.x;
          content.scrollLeft(pos.left + dy / scrollRatio);
        };

        const mouseUpHandler = () => {
          document.removeEventListener('mousemove', mouseMoveHandler);
          document.removeEventListener('mouseup', mouseUpHandler);
        };

        const mouseDownThumbHandler = (e) => {
          pos = {
            left: content.scrollLeft,
            x: e.clientX,
          };

          document.addEventListener('mousemove', mouseMoveHandler);
          document.addEventListener('mouseup', mouseUpHandler);
        };

        thumb.addEventListener('mousedown', mouseDownThumbHandler);

        const trackClickHandler = (e) => {
          const bound = track.getBoundingClientRect();
          const percentage = (e.clientY - bound.top) / bound.height;
          content.scrollTop = percentage * (content.scrollHeight - content.clientHeight);
        };

        track.addEventListener('click', trackClickHandler);
      }
    }
  }
}

function useScrollBar() {
  return {
    customScrollbarX,
    changeScrollbarPosition,
  };
}

export default useScrollBar;
